import { render, staticRenderFns } from "./material-form.vue?vue&type=template&id=9be6803e&scoped=true&lang=pug&"
import script from "./material-form.vue?vue&type=script&lang=ts&"
export * from "./material-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be6803e",
  null
  
)

export default component.exports